import {Component, OnInit, ViewChild} from '@angular/core';
import {PromotionsSModel} from '../../../../../components/parentchild/promotionsS/promotionsS.model';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {ParentChildService} from '../../../../../components/parentchild/parentchild.service';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmationService} from 'primeng/primeng';
import {LocalStorageService} from 'ng2-webstorage';


@Component({
  selector: 'app-student-profile',
  templateUrl: './student-promotion.component.html',
  styleUrls: ['./student-promotion.component.css']
})

export class StudentPromotionComponent implements OnInit {

  public selected_branch: any;
  public Branches: any;
  public selectedYear1: any;
  public selectedGrade1: any;
  public selectedSection1: any;
  public selectedYear2: any;
  public selectedGrade2: any;
  public selectedSection2: any;
  public YearData: any;
  public mappedData: any;
  public sectionList1: any;
  public sectionList2: any;
  public students1: any;
  public students2: any;

  public token: any;
  public SchoolUserId: any;
  public BranchId: any;
  public SchoolId: any;

  selectedStudents: any[] = [];


  public addDepartmentmodel = new PromotionsSModel();
  public schoolId: any;
  public department: any;
  // display: boolean = false;
  display = "none"
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public searchString: string;
  public spinnershow: boolean = false;
  public rolesList: any;
  public departmentList: any;
  public info:boolean=false;
  public isList:boolean=true;


  public allStudents:boolean=false;


  constructor(private dataAnalyticsService: DataAnalyticsService,    private msgService: MessageService,
              private parentChildService: ParentChildService, private messageService: MessageService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService) {
    this.schoolId = this.localStorage.retrieve('SchoolId');

  }

  ngOnInit() {
    this.getYearData();
  }

  confirmOnClick(){
    // alert("clicked");
    this.token = this.localStorage.retrieve('token')
    this.SchoolId = this.localStorage.retrieve('schoolid')
    this.SchoolUserId = this.localStorage.retrieve('id')
    this.BranchId = this.localStorage.retrieve('branchid')



    let payload: any = {
      AccedemicYearID: this.selectedYear2.YearId,
      SchoolUserId: this.SchoolUserId,
      BranchId: this.BranchId,
      SchoolId: this.SchoolId,
      Standardsectionmappingid: this.selectedSection2.SectionId,
      StandardId: this.selectedGrade2.standardId,
      SectionId: this.selectedSection2.SectionId,
      students: this.selectedStudents,
      StudentCount: this.selectedStudents.length
    }

    console.log(this.selectedStudents);
    console.log(payload);

    this.dataAnalyticsService.studentPromotion(payload).finally(() => {
    }).subscribe(
      response => {
        console.log(response);
        this.msgService.add({
          severity: "success",
          summary: "Talkative Parents",
          detail: 'Students successfully promoted !',
        });
        this.selectedStudents = [];
        this.students1 = [];
        this.sectionList1 = [];
        this.ngOnInit();
      },
      error => {
        console.error(error);
        this.msgService.add({
          severity: "error",
          summary: "Talkative Parents",
          detail: 'Students promotion failed !',
        });
      }
    );
  }


  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        this.YearData.sort((a, b) => b.AcademicYear.localeCompare(a.AcademicYear));

        try {
          this.selectedYear1 = this.YearData[1];
          this.selectedYear2 = this.YearData[0];
        } catch (error) {

        }

        this.getClassSection();
      }
    )
  }

  private getClassSection() {
    this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        this.mappedData = mappedData;
        try {
          this.selectedGrade1 = mappedData[0];
          this.sectionList1 = mappedData[0].Sections;
          this.sectionList1.sort((a, b) => a.sectionName.localeCompare(b.sectionName));
          this.selectedSection1 = mappedData[0].Sections[0];
          this.getStudentData1(this.selectedGrade1.standardId, this.selectedSection1.SectionId, this.selectedYear1.YearId);
        } catch (error) {
        }
        try {
          this.selectedGrade2 = mappedData[1];
          this.sectionList2 = mappedData[1].Sections;
          this.sectionList2.sort((a, b) => a.sectionName.localeCompare(b.sectionName));
          this.selectedSection2 = mappedData[1].Sections[0];
          this.getStudentData2(this.selectedGrade2.standardId, this.selectedSection2.SectionId, this.selectedYear2.YearId);
        } catch (error) {
        }
      },
      error => {
      });
  };


  getSectionByGrade1(grade) {
    this.sectionList1 = grade.Sections;
    this.sectionList1.sort((a, b) => {
      if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
        return -1;
      }
      if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    this.selectedStudents = [];
    try {
      this.selectedSection1 = grade.Sections[0];
      this.getStudentData1(this.selectedGrade1.standardId, this.selectedSection1.SectionId, this.selectedYear1.YearId);
    } catch (error) {

    }
  }

  getSectionByGrade2(grade) {
    this.sectionList2 = grade.Sections;
    this.sectionList2.sort((a, b) => {
      if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
        return -1;
      }
      if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    try {
      this.selectedSection2 = grade.Sections[0];
      this.getStudentData2(this.selectedGrade2.standardId, this.selectedSection2.SectionId, this.selectedYear2.YearId);
    } catch (error) {

    }
  }

  getGclClassesListById1(year, grade, section){
    console.log(year, grade, section);
    this.selectedStudents = [];
    this.selectedStudents = [];
    this.getStudentData1(this.selectedGrade1.standardId, this.selectedSection1.SectionId, this.selectedYear1.YearId);
  }

  getGclClassesListById2(year, grade, section){
    console.log(year, grade, section);
    this.getStudentData2(this.selectedGrade2.standardId, this.selectedSection2.SectionId, this.selectedYear2.YearId);
  }


  private getStudentData1(StandardId,SectionId,AcademicYear) {
    this.dataAnalyticsService.getStudents(StandardId,SectionId,AcademicYear)._finally(() => { }).subscribe(
      response => {
        this.students1 = response['studentsList'];
        this.students1 = this.students1.filter(element => element.Statusid !== 0);
        console.log("studentsList1", this.students1);
      }
    )
  }

  private getStudentData2(StandardId,SectionId,AcademicYear) {
    this.dataAnalyticsService.getStudents(StandardId,SectionId,AcademicYear)._finally(() => { }).subscribe(
      response => {
        this.students2 = response['studentsList'];
        this.students2 = this.students2.filter(element => element.Statusid !== 0);
        console.log("studentsList2", this.students2);
      }
    )
  }

  checkStudent(e, student) {
    console.log(student);
    const std = {
      'ChildId': student.StudentId,
      'AdmissionId': ''
    }

    if (e.target.checked) {
      // Add the student to the selectedStudents array
      this.selectedStudents.push(std);
    } else {
      // Find the index of the student in the selectedStudents array
      const index = this.selectedStudents.findIndex(s => s.ChildId === std.ChildId);

      // If found, remove the student from the array
      if (index !== -1) {
        this.selectedStudents.splice(index, 1);
      }
    }

    // console.log(this.selectedStudents);
  }


  selectAllStudents(e) {

    if (e.target.checked) {
      this.allStudents = true;
      // Clear the array before adding all students
      this.selectedStudents = [];

      // Iterate over students1 and update selected status and add to selectedStudents
      this.students1.forEach(student => {
        if (student.Promoted !== 1) { // Check if the student is not promoted
          // student.selected = true;
          this.selectedStudents.push({
            'ChildId': student.StudentId,
            'AdmissionId': ''
          });
        }
      });
    } else {
      this.allStudents = false;
      // Iterate over students1 and update selected status
      // this.students1.forEach(student => {
      //   student.selected = false;
      // });
      // Clear the selectedStudents array
      this.selectedStudents = [];
    }

    console.log(this.selectedStudents);

  }


}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/student-details/student-promotion/student-promotion.component.ts